<div class="flex flex-wrap mt-8 mb-6 max-w-7xl mx-auto">

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        <div class="flex flex-row gap-2 justify-center">
            <!-- <button type="button" (click)="assignToGradeNotificationGroups()"
                colors="bg-primary-500 hover:bg-primary-300">Assign Notifications</button> -->
            @if (canCreateNotice()) {
            <app-btn-route routeTo="create" btnText="New Notice" icon="fa fa-add"
                colors="bg-primary-500 hover:bg-primary-300"></app-btn-route>
            }
        </div>
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            Noticeboard
        </h1>
    </div>

    <div class="flex flex-col gap-2 w-full">
        @let loading = (loading$ | async) ?? false;
        @let notices = (notices$ | async);

        @if (loading && (notices == null || notices.length === 0)) {
        <!-- Initial full-page skeleton (first load only) -->
        <div class="bg-white shadow rounded-md p-4 w-full mx-auto">
            <div class="animate-pulse flex space-x-4">
                <div class="rounded bg-slate-200 h-10 w-10"></div>
                <div class="flex-1 space-y-6 py-1">
                    <div class="h-4 bg-slate-200 rounded"></div>
                    <div class="space-y-3">
                        <div class="grid grid-cols-3 gap-4">
                            <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                            <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                        </div>
                        <div class="h-4 bg-slate-200 rounded"></div>
                    </div>
                </div>
            </div>
        </div>
        } @else {
        <div class="grid grid-cols-1 gap-4">
            @for (item of notices; track item.id) {
            <div class="bg-white shadow-lg rounded-lg w-full px-4 py-3 cursor-default flex flex-row items-start">
                <div class="inline-block flex-none">
                    @if (item?.imageUrl) {
                    <img [src]="item?.imageUrl" (click)="onViewImage(item)"
                        class="min-h-12 max-h-12 max-w-12 min-w-12 bg-white object-cover object-center rounded border-none cursor-pointer hover:scale-105 transition-transform duration-150"
                        title="Click to view full image" />
                    } @else {
                    <div
                        class="bg-primary-100 uppercase truncate text-primary-500 text-base flex justify-center items-center text-center h-12 w-12 rounded">
                        {{ item?.title | initials }}
                    </div>
                    }
                </div>
                <div class="flex flex-col items-start col-span ml-3 w-full">
                    <div class="flex flex-row justify-between w-full gap-4">
                        <div class="flex flex-col">
                            <div class="flex flex-row items-center gap-2">
                                <time-before class="flex items-center"
                                    [dateValue]="item?.publishOn?.toDate()"></time-before>
                                @if (item?.isGradeNotice) {
                                <div class="h-1 w-1 bg-primary-200 rounded-full inline"></div>
                                <span class="text-primary-200 truncate text-xs inline-flex">
                                    {{ item?.gradeName }}</span>
                                }
                            </div>
                            <div>
                                <span
                                    class="font-semibold text-blueGray-600 break-words whitespace-normal leading-snug">
                                    {{ item?.title }}
                                </span>
                            </div>
                        </div>
                        @if (canEditDeleteNotice(item)) {
                        <div class="flex flex-row gap-2 whitespace-nowrap">
                            <app-btn-fab (click)="onEdit(item)" icon="fas fa-edit" tooltip="Edit"></app-btn-fab>
                            <app-btn-fab (click)="onDelete(item)" icon="fa fa-trash-can"
                                textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                        </div>
                        }
                    </div>
                    <span
                        class="text-primary-400 inline-flex text-xs whitespace-pre-line leading-relaxed mt-4">{{item?.description}}</span>

                    <!-- Attachments List -->
                    @if (item.attachments && item.attachments.length > 0) {
                    <div class="mt-3 w-full">
                        <div class="flex flex-col gap-2">
                            @for (attachment of item.attachments; track attachment.name) {
                            <a [href]="attachment.url" target="_blank"
                                class="flex items-center gap-2.5 p-2.5 bg-blueGray-50 border border-blueGray-200/60 hover:border-primary-500 rounded-lg shadow-sm transition-all duration-150">
                                <i
                                    [class]="attachment.url.toLowerCase().endsWith('.pdf') ? 'far fa-file-pdf text-primary-500 text-sm' : 'far fa-file-lines text-primary-500 text-sm'"></i>
                                <span class="text-xs font-semibold text-blueGray-700 truncate"
                                    [title]="attachment.name">
                                    {{ attachment.name }}
                                </span>
                            </a>
                            }
                        </div>
                    </div>
                    }

                    <!-- Sub-Events Table -->
                    @if (hasEvents(item.events)) {
                    <div class="mt-4 w-full">
                        <div class="overflow-x-auto rounded-lg border border-blueGray-200 shadow-sm w-full">
                            <table class="w-full text-left border-collapse bg-white">
                                <thead>
                                    <tr class="bg-blueGray-50/75 border-b border-blueGray-200">
                                        <th class="px-3 py-2 text-xs font-bold titlecase text-blueGray-500">Event /
                                            Session Name</th>
                                        <th class="px-3 py-2 text-xs font-bold titlecase text-blueGray-500 text-right">
                                            Date & Time</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-blueGray-100">
                                    @for (ev of getSortedEvents(item.events); track ev.name) {
                                    <tr class="hover:bg-blueGray-50/20 transition-colors">
                                        <td class="px-3 py-2 text-xs font-semibold text-blueGray-800">{{ ev.name }}</td>
                                        <td class="px-3 py-2 text-xs text-blueGray-600 text-right font-medium">
                                            {{ ev.date.toDate() | moment: 'Do MMM YYYY, h:mm a' }}
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    }
                </div>
            </div>
            } @empty {
            <div class="px-6 py-4 text-sm text-center font-semibold border-0 whitespace-nowrap">
                No Notices Available
            </div>
            }

            <!-- Inline loading indicator shown while fetching more -->
            @if (loading) {
            <div class="bg-white shadow rounded-md p-4 w-full mx-auto">
                <div class="animate-pulse flex space-x-4">
                    <div class="rounded bg-slate-200 h-10 w-10"></div>
                    <div class="flex-1 space-y-6 py-1">
                        <div class="h-4 bg-slate-200 rounded"></div>
                        <div class="space-y-3">
                            <div class="grid grid-cols-3 gap-4">
                                <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                                <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                            </div>
                            <div class="h-4 bg-slate-200 rounded"></div>
                        </div>
                    </div>
                </div>
            </div>
            }

            @if ((notices?.length ?? 0) > 0) {
            <div class="flex flex-row w-full justify-center px-4 mt-2">
                <app-btn-more (click)="addMore()" [isDisabled]="loading ?? false"></app-btn-more>
            </div>
            }
        </div>
        }
    </div>
</div>